export default __webpack_public_path__ + "static/media/4.5b8304da.PNG";